/* Shared PDP transition for connected color, motor and finish selectors. */
(() => {
  if (window.FPConnectedProductTransition) return;
  const storageKey = 'fp:connected-product-selection';
  const contextParams = ['preview_theme_id', '_fd', 'pb', 'locale', 'country', 'currency'];
  const cache = new Map();
  const cacheTtl = 20000;
  const maxCachedProducts = 4;
  const prefetchTimers = new WeakMap();
  const restorers = new Map();
  let prefetchSuspendedUntil = 0;
  let backgroundPrefetchActive = false;
  let pendingBackgroundPrefetchItem = null;
  let generation = 0;
  let historyBase = null;
  let pendingItem = null;
  let pendingContainer = null;
  let pageHidden = false;
  let idleTimer = null;

  function contextFrom(text) {
    const matches = [...text.matchAll(/<script\b[^>]*\bdata-fp-connected-context\b[^>]*>([\s\S]*?)<\/script>/gi)];
    if (matches.length !== 1 || matches[0][1].length > 32768) throw new Error('Contexto da PDP incompleto');
    const data = JSON.parse(matches[0][1]);
    if (!/^\d+$/.test(data.productId) || typeof data.template !== 'string' || typeof data.url !== 'string') throw new Error('Identidade da PDP inválida');
    return data;
  }

  function colorItem(url) {
    return [...document.querySelectorAll('fp-colors-optimizer-swatch [data-fp-connected-product-url]')]
      .find(item => new URL(item.href, location.href).pathname === url.pathname);
  }

  function legacyIdentity(context, main) {
    if (context?.renderTemplate !== 'legacy-unificada' || !context.profile || !context.group) return null;
    if (main?.dataset.fpLegacyControl !== 'a' || main.dataset.fpLegacyRenderTemplate !== context.renderTemplate ||
      main.dataset.fpLegacyProfile !== context.profile || main.dataset.fpLegacyGroup !== context.group) return null;
    return { renderTemplate: context.renderTemplate, profile: context.profile, group: context.group };
  }

  function legacyPage() {
    return new URL(location.href).searchParams.get('view') === 'legacy-unificada' ||
      Boolean(document.querySelector('#MainContent [data-fp-legacy-control="a"]'));
  }

  function legacyTarget(url) {
    return [...document.querySelectorAll('fp-colors-optimizer-swatch [data-fp-connected-product-url], fp-connected-product-cards [data-fp-connected-product-url]')]
      .some(item => item.dataset.fpLegacyRenderTemplate === 'legacy-unificada' && new URL(item.href, location.href).pathname === url.pathname);
  }

  function partialRequest(url, item) {
    if (!item?.closest('fp-colors-optimizer-swatch') || !window.FPDeferredPdpSections) return null;
    // The reviews SDK has no verified product-switch API. A real navigation
    // resets its identity safely when it is already loading or mounted.
    if (document.querySelector('script[src*="trustvox.com.br/sincero/"]')) return null;
    const main = document.querySelector('#MainContent .section-main-product');
    const node = main?.querySelector('[data-fp-connected-context]');
    if (!node || !item.hasAttribute('data-fp-connected-template')) return null;
    let context;
    try { context = JSON.parse(node.textContent); } catch (_) { return null; }
    if (!context || typeof context !== 'object') return null;
    if (!context.familyId || context.familyId !== item.closest('fp-colors-optimizer-swatch').dataset.fpFamilyId) return null;
    const legacy = legacyPage() || context.renderTemplate === 'legacy-unificada';
    const identity = legacy ? legacyIdentity(context, main) : null;
    if (legacy) {
      if (!identity || url.searchParams.get('view') !== identity.renderTemplate ||
        item.dataset.fpLegacyRenderTemplate !== identity.renderTemplate || item.dataset.fpLegacyProfile !== identity.profile ||
        item.dataset.fpLegacyGroup !== identity.group) return null;
      const preview = url.searchParams.get('preview_theme_id');
      if (preview && String(window.Shopify?.theme?.id || '') !== preview) return null;
    } else if (context.template !== item.dataset.fpConnectedTemplate) return null;
    const mainId = main.closest('.shopify-section')?.id?.replace(/^shopify-section-/, '');
    const breadcrumbId = document.querySelector('#MainContent .fp-breadcrumbs')?.closest('.shopify-section')?.id?.replace(/^shopify-section-/, '');
    if (!mainId || !main.querySelector('variant-width-height')) return null;
    const ids = [mainId, ...(breadcrumbId ? [breadcrumbId] : []), 'fp-cbb-manifest'];
    const requestUrl = new URL(url);
    requestUrl.searchParams.delete('section_id');
    requestUrl.searchParams.delete('option_values');
    requestUrl.searchParams.set('sections', ids.join(','));
    return { requestUrl, ids, mainId, breadcrumbId, context, productId: item.dataset.fpConnectedProductId,
      mainDomId: main.id, legacy: identity };
  }

  function validatePartial(sections, mode, url) {
    if (!sections || mode.ids.some(id => typeof sections[id] !== 'string' || !sections[id] || sections[id].includes('Liquid error'))) throw new Error('Seções de destino incompletas');
    const context = contextFrom(sections[mode.mainId]);
    if (context.productId !== mode.productId || context.familyId !== mode.context.familyId ||
      (!mode.legacy && context.template !== mode.context.template) || new URL(context.url, location.href).pathname !== url.pathname) throw new Error('Produto retornado não corresponde ao selecionado');
    if (mode.legacy) {
      const parsed = new DOMParser().parseFromString(sections[mode.mainId], 'text/html');
      const wrapper = parsed.getElementById(`shopify-section-${mode.mainId}`);
      const mains = wrapper?.querySelectorAll('.section-main-product');
      const main = mains?.length === 1 ? mains[0] : null;
      const identity = legacyIdentity(context, main);
      if (!identity || main.id !== mode.mainDomId || main.dataset.fpProductId !== context.productId ||
        identity.profile !== mode.legacy.profile || identity.group !== mode.legacy.group ||
        identity.renderTemplate !== mode.legacy.renderTemplate) throw new Error('Contrato Legacy de destino incompatível');
    }
    const canonical = new URL(context.canonical, location.href);
    if (canonical.origin !== location.origin || canonical.pathname !== url.pathname) throw new Error('Canonical de destino inválido');
    return { partial: true, sections, context, mode, at: Date.now(), url: url.toString() };
  }

  function clearPending() {
    pendingItem?.removeAttribute('data-fp-connected-pending');
    pendingItem?.removeAttribute('aria-busy');
    pendingContainer?.removeAttribute('aria-busy');
    pendingItem = null;
    pendingContainer = null;
  }

  function markPending(item, options) {
    clearPending();
    if (!item) return;
    pendingItem = item;
    pendingContainer = item.closest('fp-colors-optimizer-swatch, fp-connected-product-cards');
    if (options.showLoading === true) pendingItem.setAttribute('data-fp-connected-pending', '');
    pendingItem.setAttribute('aria-busy', 'true');
    pendingContainer?.setAttribute('aria-busy', 'true');
  }

  function movePending(root, productId, options) {
    const source = options.pendingItem?.closest('fp-colors-optimizer-swatch, fp-connected-product-cards');
    const kind = source?.dataset.fpSelectorKind;
    const container = [...root.querySelectorAll(source?.tagName.toLowerCase() || 'fp-colors-optimizer-swatch')]
      .find(node => !kind || node.dataset.fpSelectorKind === kind);
    const item = [...(container?.querySelectorAll('[data-fp-connected-product-id]') || [])]
      .find(node => node.dataset.fpConnectedProductId === String(productId));
    markPending(item, options);
  }

  function stopLoading(turn) {
    if (turn !== generation) return;
    clearPending();
  }

  function destination(href) {
    const url = new URL(href, location.href);
    if (url.origin !== location.origin || !url.pathname.startsWith(`${window.Shopify?.routes?.root || '/'}products/`)) throw new Error('Produto de destino inválido');
    const current = new URL(location.href);
    const legacy = legacyPage() && legacyTarget(url);
    if (legacy) {
      const explicitParams = new Set(url.searchParams.keys());
      for (const [name, value] of current.searchParams) {
        if (!['variant', 'option_values', 'section_id', 'sections', 'view'].includes(name) && !explicitParams.has(name)) url.searchParams.append(name, value);
      }
      url.searchParams.set('view', 'legacy-unificada');
      if (!url.hash) url.hash = current.hash;
    } else {
      for (const name of contextParams) {
        if (current.searchParams.has(name)) url.searchParams.set(name, current.searchParams.get(name));
      }
    }
    // Shopify removes the preview query after loading a draft. Keep subsequent
    // product requests and the hard-navigation fallback on that same draft.
    const theme = window.Shopify?.theme;
    if (theme?.id && theme.role === 'unpublished' && (!legacy || !url.searchParams.has('preview_theme_id'))) url.searchParams.set('preview_theme_id', String(theme.id));
    url.searchParams.delete('variant');
    if (legacy) url.searchParams.delete('option_values');
    return url;
  }

  function capture() {
    const root = document.querySelector('#MainContent');
    const fields = root?.querySelector('variant-width-height');
    return {
      width: Number(fields?.querySelector('#select-width')?.value) || null,
      height: Number(fields?.querySelector('#select-height')?.value) || null,
      cordinha: root?.querySelector('.section-main-product [name="lado-corda"]:checked')?.value || '',
      quantity: Number(root?.querySelector('.section-main-product [name="quantity"]')?.value) || 1,
      selectors: { ...Object.fromEntries([...root?.querySelectorAll('[data-fp-family-selector-raw]') || []]
        .map(field => [field.dataset.fpFamilySelectorStateKey || field.dataset.fpFamilySelectorKey, field.value])
        .filter(([key]) => key)), ...window.FPProductOptions?.capture(root) },
    };
  }

  function persist(url, selection) {
    try { sessionStorage.setItem(storageKey, JSON.stringify({ path: url.pathname, at: Date.now(), selection })); } catch (_) { /* navigation still works */ }
  }

  function clear() {
    try { sessionStorage.removeItem(storageKey); } catch (_) { /* noop */ }
  }

  async function restore(selection, root = document.querySelector('#MainContent'), turn = generation) {
    window.FPProductOptions?.restore(selection, root);
    const dimensions = root?.querySelector('variant-width-height');
    if (dimensions) {
      await customElements.whenDefined('variant-width-height');
      if (typeof dimensions.restoreConnectedSelection !== 'function') throw new Error('Seletor CBB indisponível');
      const restored = dimensions.connectedRestorePromise || dimensions.restoreConnectedSelection(selection);
      if (!await restored) throw new Error('Variante CBB não confirmada');
    }
    if (turn !== generation) return;
    for (const restoreSelection of restorers.values()) {
      await restoreSelection(selection);
      if (turn !== generation) return;
    }
  }

  function warmPrimaryImage(page, entry, manual) {
    if (!entry) return;
    if (entry.primaryImage) {
      if (manual) entry.primaryImage.fetchPriority = 'high';
      return;
    }
    const selector = '#MainContent media-gallery[data-fp-priority-media] .is-active modal-opener img[src]';
    const current = document.querySelector(selector);
    // Speculation must not compete with the image the customer is still opening.
    if (!manual && current && !current.complete) return;
    const primary = page.partial ? page.context.image : page.querySelector(selector);
    if (!primary) return;
    const image = new Image();
    image.decoding = 'async';
    image.fetchPriority = manual ? 'high' : 'low';
    // Match the gallery's responsive candidate so the swap reuses the same image.
    image.sizes = page.partial ? current?.getAttribute('sizes') || '100vw' : primary.getAttribute('sizes') || '100vw';
    image.srcset = page.partial ? primary.srcset || '' : primary.getAttribute('srcset') || '';
    const src = page.partial ? primary.src : primary.getAttribute('src');
    if (!src || new URL(src, location.href).protocol !== 'https:') return;
    image.src = src;
    entry.primaryImage = image;
  }

  function prefetch(href, manual = false, item = null) {
    if (!manual && Date.now() < prefetchSuspendedUntil) return Promise.resolve(null);
    const connection = navigator.connection;
    if (!manual && (document.hidden || connection?.saveData || /^(?:(slow-)?2g|3g)$/.test(connection?.effectiveType || ''))) return Promise.resolve(null);
    let url;
    try { url = destination(href); } catch (_) { return Promise.resolve(null); }
    item ||= colorItem(url);
    const mode = partialRequest(url, item);
    if (!manual && item?.closest('fp-colors-optimizer-swatch') && !mode) return Promise.resolve(null);
    const requestKey = (mode?.requestUrl || url).toString();
    // A cached section response belongs to one rendered contract/section instance.
    const key = mode?.legacy ? `${requestKey}|${mode.legacy.profile}|${mode.legacy.group}|${mode.mainId}|${mode.mainDomId}` : requestKey;
    for (const [cachedKey, entry] of cache) {
      // A new click supersedes other pending destinations, but reuses its own prefetch.
      if ((manual && cachedKey !== key && entry.pending) || Date.now() - entry.at >= cacheTtl) {
        entry.controller.abort();
        cache.delete(cachedKey);
      }
    }
    const existing = cache.get(key);
    if (existing) {
      if (manual) existing.manual = true;
      return existing.promise.then(page => {
        warmPrimaryImage(page, existing, manual);
        return page;
      });
    }
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    const entry = { at: Date.now(), controller, pending: true, manual };
    const promise = fetch(requestKey, { credentials: 'same-origin', signal: controller.signal, priority: manual ? 'high' : 'low' }).then(async response => {
      if (response.status === 429 || response.status >= 500) {
        const retry = response.headers.get('Retry-After')?.trim();
        const delay = retry && /^\d+$/.test(retry) ? Number(retry) * 1000 : Date.parse(retry) - Date.now();
        prefetchSuspendedUntil = Date.now() + (Number.isFinite(delay) && delay >= 0 ? delay : 60000);
      }
      if (!response.ok) throw new Error(`PDP HTTP ${response.status}`);
      const html = await response.text();
      if (controller.signal.aborted) throw new DOMException('Cancelado', 'AbortError');
      const page = mode ? validatePartial(JSON.parse(html), mode, url) : new DOMParser().parseFromString(html, 'text/html');
      if (!mode && (!page.querySelector('#MainContent .section-main-product') || html.includes('Liquid error'))) throw new Error('PDP de destino incompleta');
      warmPrimaryImage(page, cache.get(key), manual);
      return page;
    }).catch(error => {
      if (cache.get(key)?.promise === promise) cache.delete(key);
      throw error;
    }).finally(() => {
      clearTimeout(timeout);
      entry.pending = false;
    });
    entry.promise = promise;
    cache.set(key, entry);
    while (cache.size > maxCachedProducts) {
      const oldest = [...cache.keys()].find(key => !cache.get(key).pending || !cache.get(key).manual);
      if (!oldest) break;
      cache.get(oldest).controller.abort();
      cache.delete(oldest);
    }
    return promise;
  }

  function cancelScheduledPrefetch(item) {
    const timer = prefetchTimers.get(item);
    if (timer) clearTimeout(timer);
    prefetchTimers.delete(item);
    if (pendingBackgroundPrefetchItem === item) pendingBackgroundPrefetchItem = null;
  }

  function runBackgroundPrefetch(item) {
    if (pageHidden || !item?.isConnected || item.hasAttribute('aria-current')) return;
    if (backgroundPrefetchActive) {
      pendingBackgroundPrefetchItem = item;
      return;
    }
    backgroundPrefetchActive = true;
    prefetch(item.href, false, item).catch(() => {}).finally(() => {
      backgroundPrefetchActive = false;
      const pending = pendingBackgroundPrefetchItem;
      pendingBackgroundPrefetchItem = null;
      if (pending) runBackgroundPrefetch(pending);
    });
  }

  function schedulePrefetch(item, delay = 240) {
    if (!item || item.hasAttribute('aria-current')) return;
    if (delay <= 0) {
      cancelScheduledPrefetch(item);
      runBackgroundPrefetch(item);
      return;
    }
    if (prefetchTimers.has(item)) return;
    const timer = setTimeout(() => {
      prefetchTimers.delete(item);
      runBackgroundPrefetch(item);
    }, delay);
    prefetchTimers.set(item, timer);
  }

  function removeReplacedModals(next) {
    // Native modals move to body, outside the section being replaced.
    for (const replacement of next.querySelectorAll('product-modal[id], modal-dialog[id]')) {
      let previous;
      while ((previous = document.getElementById(replacement.id)) &&
        ['PRODUCT-MODAL', 'MODAL-DIALOG'].includes(previous.tagName)) {
        if (previous.hasAttribute('open')) previous.hide();
        previous.remove();
      }
    }
  }

  async function transition(href, targetProductId, options = {}) {
    const url = destination(href);
    const selection = options.selection || capture();
    persist(url, selection);
    const turn = ++generation;
    clearTimeout(idleTimer);
    pendingBackgroundPrefetchItem = null;
    if (options.fromHistory) historyBase = null;
    else if (!historyBase) historyBase = { url: location.href, selection: capture() };
    markPending(options.pendingItem, options);
    document.querySelector('#MainContent variant-width-height')?.suspendConnectedTransition?.();
    document.dispatchEvent(new CustomEvent('fp:connected-product-loading', { detail: { url: url.toString() } }));
    try {
      const item = options.pendingItem || colorItem(url);
      if ((legacyPage() || item?.closest('fp-colors-optimizer-swatch')) && !partialRequest(url, item)) throw new Error('PDP requer navegação completa');
      const page = await prefetch(url.toString(), true, item);
      if (turn !== generation) return;
      if (page?.partial) {
        if (targetProductId && page.context.productId !== String(targetProductId)) throw new Error('Identidade da cor inválida');
        if (page.mode.legacy) {
          const currentMode = partialRequest(url, item);
          if (!currentMode || currentMode.mainId !== page.mode.mainId || currentMode.mainDomId !== page.mode.mainDomId ||
            currentMode.legacy?.profile !== page.mode.legacy.profile || currentMode.legacy?.group !== page.mode.legacy.group) throw new Error('Instância Legacy mudou durante a navegação');
          validatePartial(page.sections, currentMode, url);
        }
        const imported = swapPartial(page, selection, options, turn);
        await restore(selection, imported, turn);
        if (turn !== generation) return;
        imported.querySelector('.section-main-product')?.removeAttribute('data-fp-connected-partial-loading');
        document.title = page.context.documentTitle;
        document.querySelector('link[rel="canonical"]')?.setAttribute('href', page.context.canonical);
        document.querySelector('meta[name="description"]')?.setAttribute('content', page.context.description);
      } else {
      const next = page.querySelector('#MainContent');
      const actualId = next?.querySelector('.section-main-product')?.dataset.fpProductId;
      if (!next || (targetProductId && String(actualId) !== String(targetProductId))) throw new Error('Produto retornado não corresponde ao selecionado');
      const current = document.querySelector('#MainContent');
      if (!current) throw new Error('PDP atual indisponível');
      const imported = document.importNode(next, true);
      const dimensions = imported.querySelector('variant-width-height');
      if (!dimensions) throw new Error('Seletor CBB de destino indisponível');
      dimensions.fpConnectedSelection = selection;
      movePending(imported, actualId, options);
      removeReplacedModals(imported);
      current.replaceWith(imported);
      document.dispatchEvent(new CustomEvent('fp:connected-product-swapped', { detail: { url: url.toString(), targetProductId } }));
      await restore(selection, imported, turn);
      if (turn !== generation) return;
      document.title = page.title;
      const canonical = document.querySelector('link[rel="canonical"]');
      const nextCanonical = page.querySelector('link[rel="canonical"]');
      if (canonical && nextCanonical) canonical.href = nextCanonical.href;
      }
      if (!options.fromHistory) {
        history.replaceState({ ...history.state, fpConnected: { selection: historyBase.selection } }, '', historyBase.url);
        history.pushState({ fpConnected: { selection } }, '', url.toString());
      }
      historyBase = null;
      clear();
      document.dispatchEvent(new CustomEvent('fp:connected-product-settled', { detail: { selection } }));
      scheduleIdlePrefetch();
    } catch (error) {
      if (turn !== generation) return;
      // A normal navigation is the last resort and retains the short-lived selection.
      location.assign(url.toString());
    } finally {
      stopLoading(turn);
    }
  }

  function swapPartial(page, selection, options, turn) {
    const { mode, sections, context } = page;
    const parse = id => {
      const root = new DOMParser().parseFromString(sections[id], 'text/html').getElementById(`shopify-section-${id}`);
      if (!root) throw new Error('Section Rendering incompleto');
      return document.importNode(root, true);
    };
    const next = parse(mode.mainId);
    const nextMain = next.querySelector('.section-main-product');
    const dimensions = next.querySelector('variant-width-height');
    const current = document.getElementById(`shopify-section-${mode.mainId}`);
    const breadcrumb = mode.breadcrumbId ? parse(mode.breadcrumbId) : null;
    if (!current || !dimensions || nextMain?.dataset.fpProductId !== context.productId) throw new Error('PDP crítica incompleta');
    dimensions.fpConnectedSelection = selection;
    const manifestURL = new URL(page.url);
    manifestURL.searchParams.set('section_id', 'fp-cbb-manifest');
    dimensions.fpConnectedManifestSeed = { text: sections['fp-cbb-manifest'], url: manifestURL.toString(), at: page.at };
    nextMain.setAttribute('data-fp-connected-partial-loading', '');
    window.FPDeferredPdpSections.replace(context, page.url, [mode.mainId, mode.breadcrumbId], turn);
    current.dispatchEvent(new CustomEvent('shopify:section:unload', { bubbles: true, detail: { sectionId: mode.mainId } }));
    removeReplacedModals(next);
    current.replaceWith(next);
    if (breadcrumb) document.getElementById(`shopify-section-${mode.breadcrumbId}`)?.replaceWith(breadcrumb);
    const identities = new Set(['_productId', '_productName', '_productPhotos']);
    window._trustvox = (Array.isArray(window._trustvox) ? window._trustvox : []).filter(row => !identities.has(row[0]));
    window._trustvox.push(['_productId', context.productId], ['_productName', context.title], ['_productPhotos', [context.image?.src || '']]);
    movePending(next, context.productId, options);
    document.dispatchEvent(new CustomEvent('fp:connected-product-swapped', { detail: { url: page.url, targetProductId: context.productId, partial: true } }));
    next.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: mode.mainId } }));
    return document.getElementById('MainContent');
  }

  function scheduleIdlePrefetch() {
    clearTimeout(idleTimer);
    const turn = generation;
    idleTimer = setTimeout(() => {
      if (turn !== generation || pageHidden || document.hidden || document.readyState !== 'complete') return;
      const fields = document.querySelector('#MainContent variant-width-height');
      const image = document.querySelector('#MainContent media-gallery .is-active img[src]');
      if (!fields || fields.state !== 'ready' || (image && !image.complete)) return;
      const items = [...document.querySelectorAll('fp-colors-optimizer-swatch [data-fp-connected-product-url]:not([aria-current])')]
        .slice(0, matchMedia('(max-width: 749px)').matches ? 2 : 3);
      const warm = async () => {
        for (const item of items) {
          if (turn !== generation || document.hidden || pageHidden || backgroundPrefetchActive) return;
          backgroundPrefetchActive = true;
          try { await prefetch(item.href, false, item); } catch (_) { /* next click retains normal navigation */ }
          finally { backgroundPrefetchActive = false; }
        }
        const pending = pendingBackgroundPrefetchItem;
        pendingBackgroundPrefetchItem = null;
        if (pending) runBackgroundPrefetch(pending);
      };
      if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 1500 });
      else warm();
    }, 1000);
  }

  async function restoreAfterNavigation() {
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) { clear(); return; }
    if (!saved || saved.path !== location.pathname || Date.now() - saved.at > 5 * 60 * 1000) { clear(); return; }
    try { await restore(saved.selection || {}); } catch (_) { /* CBB shows its own error state */ } finally { clear(); }
  }

  window.FPConnectedProductTransition = {
    capture, prefetch, schedulePrefetch, cancelScheduledPrefetch, transition,
    registerRestorer(name, callback) { restorers.set(name, callback); },
  };
  window.addEventListener('pagehide', () => {
    pageHidden = true;
    ++generation;
    for (const entry of cache.values()) entry.controller.abort();
    cache.clear();
    pendingBackgroundPrefetchItem = null;
    clearPending();
    clearTimeout(idleTimer);
  });
  window.addEventListener('pageshow', () => { pageHidden = false; });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return scheduleIdlePrefetch();
    clearTimeout(idleTimer);
    pendingBackgroundPrefetchItem = null;
    for (const [key, entry] of cache) {
      if (entry.pending && !entry.manual) { entry.controller.abort(); cache.delete(key); }
    }
  });
  window.addEventListener('popstate', event => {
    if (event.state?.fpConnected) transition(location.href, null, {
      fromHistory: true,
      selection: event.state.fpConnected.selection,
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreAfterNavigation, { once: true });
  else restoreAfterNavigation();
  window.addEventListener('load', scheduleIdlePrefetch, { once: true });
  document.addEventListener('fp:cbb:state', event => { if (event.detail?.state === 'ready') scheduleIdlePrefetch(); }, true);
})();
